import { memo } from "react";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import { Icon } from "@/components/icons/Icon";
import { Link } from "react-router-dom";
import { BASE_URL } from "@/assets/constants/constants";
import { getInspectionPDF } from "@/lib/services/inspections";
import { useLoader } from "@/context/loader-context/LoaderContext";
import { appToast } from "@/lib/toast";

const InspectionButtonsHeader = ({
  id,
  isClosed,
}: {
  id: number;
  isClosed: boolean;
}) => {
  const translate = useTranslate();
  const { showLoader, hideLoader } = useLoader();

  const downloadPdf = async () => {
    try {
      showLoader();
      const response = await getInspectionPDF({ id });

      const url = window.URL.createObjectURL(
        new Blob([response], { type: "application/pdf" }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `inspection_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      appToast.success(translate("success"), translate("pdfDownloadSuccess"));
    } catch (error) {
      const e = error as Error;

      appToast.error(translate("error"), e.message);
    } finally {
      hideLoader();
    }
  };

  return (
    <div className="flex flex-row justify-between w-full">
      <Link to={`${BASE_URL}`}>
        <button className="bg-ib-whithe flex flex-row p-x-0 h-8 gap-x-2 text-ib-main items-center font-[IberiaText] text-ib-red-main hover:text-ib-red-dark">
          <Icon name="backArrow" className="size-4" />
          {translate("back")}
        </button>
      </Link>
      {isClosed ? (
        <PrimaryButton
          colour="red"
          onClick={downloadPdf}
          label={translate("exportPdf")}
          icon="downloadPdf"
          size="small"
          width="140px"
        />
      ) : null}
    </div>
  );
};

export default memo(InspectionButtonsHeader);
